@if (href()) {
	<svg
		class="azm-icon {{ iconClass() }}"
		xmlns="http://www.w3.org/2000/svg"
		[attr.width]="size()"
		[attr.height]="size()"
		[attr.aria-hidden]="ariaHidden() ? 'true' : null"
		[attr.aria-label]="resolvedAriaLabel() ? (resolvedAriaLabel()! | transloco) : null"
		[attr.role]="resolvedAriaLabel() ? 'img' : null"
	>
		<use [attr.href]="href()" [attr.xlink:href]="href()"></use>
	</svg>
}
